import { FormProvider } from '@/context/FormProvider';

import {
  type AssignAgentFormValues,
  assignAgentSchema,
  type PhoneNumberCreateFormValues,
  phoneNumberCreateSchema,
} from '@/schemas/phone-number.schema';

import type { Props } from '@/types/formik.type';
import type { PhoneNumberConfiguration } from '@/types/phone-number.type';

export const PhoneNumberFormProvider = ({ children, onSubmit }) => {
  const initialValues: PhoneNumberCreateFormValues = {
    name: '',
    phone_number: '',
    account_sid: '',
    auth_token: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={phoneNumberCreateSchema}
    >
      {children}
    </FormProvider>
  );
};

export const AssignAgentFormProvider = ({
  children,
  onSubmit,
  initialValues,
}: Props<PhoneNumberConfiguration>) => {
  const _initialValues: AssignAgentFormValues = {
    agent_id: initialValues?.agent?.id || null,
  };

  return (
    <FormProvider
      initialValues={_initialValues}
      onSubmit={onSubmit}
      validationSchema={assignAgentSchema}
    >
      {children}
    </FormProvider>
  );
};
